import {Component, OnInit, ViewChild} from '@angular/core';
import {LayoutService} from "@app/core/services/layout.service";
import { ModalDirective } from 'ngx-bootstrap';
import { NotificationService, AuthService, GeocodeService } from '@app/core/services';
import { OrdersDAO } from '@app/features/orders/orders.dao';
import { ActivatedRoute } from '@app/../../node_modules/@angular/router';
import { FileUploadComponent } from '@app/file-upload/file-upload.component';
import { OfficeService } from '@app/core/services/office.service';
import COLORS from '@app/shared/lib/colors';

import { NgbTypeahead } from '@ng-bootstrap/ng-bootstrap';
import {Observable,Subject, merge} from 'rxjs';
import {debounceTime, distinctUntilChanged, filter, map} from 'rxjs/operators';


import { TaskService } from '@app/core/services/task.service';

import * as moment from 'moment';
import { UtilsService } from '@app/core/services/utils.service';

import * as $ from 'jquery';


declare var google;


@Component({
  selector: 'ja-open-close',
  templateUrl: './open-close.component.html',
  styleUrls: ['./open-close.component.scss']
})
export class OpenCloseComponent implements OnInit{
   
  office:any;
  user:any;
  
  constructor(
    private dao: OrdersDAO,
    private ns: NotificationService,
    public auth: AuthService,
    private route: ActivatedRoute,
    private officeService: OfficeService,
    private geocodeService: GeocodeService,
    private utils: UtilsService
  ) {
  }

  async ngOnInit(){
    this.user = await this.auth.getCurrentUser();
    if(this.user.rol == 'comercio' || this.user.rol == 'caja'){
      let uidOffice = this.auth.getOfficeSelected();
      if(uidOffice!=null)
        this.office = this.officeService.getOffice(uidOffice.uid);

    }
    
    
  }

  
  show(){    
    this.ngOnInit();
    
    //this.office = this.auth.getOfficeSelected();
  } 

  open(row){
    return this.ns.confirmDialogYesNo(
      "Confirmación de acción!",
      "Desea <b>ABRIR</b> el local <b>" + row.shop.name + ' ' + row.alias + "</b> para atención en línea por <b>MegaTouch</b>, considere el horario de atención<b></b>", 
      "Local ABIERTO para atención en línea por MegaTouch",
      this.openCloseOffice.bind(this, row.uid, true));
  }

  close(row){
    return this.ns.confirmDialogYesNo(
      "Confirmación de acción!",
      "Realmente desea <b>CERRAR</b> el local <b>" + row.shop.name + ' ' + row.alias + "</b>, considere el horario de atención definido. <br>El local se abrirá automaticamente según el horario definido.", 
      "Local CERRADO para atención en línea por MegaTouch",
      this.openCloseOffice.bind(this, row.uid, false));
  }

  openCloseOffice(uid:string, open:boolean){
    return this.officeService.updateDataOffice(uid, {online: open});
  }
  

  radioChangeTime(aux: number, id){
    $('#knob'+id)
        .val(aux)
        .trigger('change');
    
  }

  

  

}
